/**
 * Handles s shader type.
 */
export enum HsShaderType {
  vertexShader = 'VERTEX_SHADER',
  fragmentShader = 'FRAGMENT_SHADER',
}
